import apiClient from '../config/axios';
import ENDPOINTS from '../constants/endpoints';

export const clientService = {
  // Get clients with pagination and filters
  getClients: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      // Build the URL with path parameters for pagination
      const url = `${ENDPOINTS.CLIENTS}/${pageSize}/${page}`;
      
      // Build query parameters for filters only
      const params = {};

      // Add filters if they exist
      if (filters.searchTerms) {
        params.SearchTerms = filters.searchTerms;
      }
      if (filters.raisonSocial) {
        params.RaisonSocial = filters.raisonSocial;
      }

      const response = await apiClient.get(url, {
        params: params
      });

      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error fetching clients:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement des clients',
        error: error.response?.data,
      };
    }
  },

  // Get client by ID
  getClientById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.CLIENTS}/Id/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Get client by ID error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors du chargement du client',
        error: error.response?.data,
      };
    }
  },

  // Create new client
  createClient: async (clientData) => {
    try {
      const response = await apiClient.post(ENDPOINTS.CLIENTS, clientData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Create client error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la création du client',
        error: error.response?.data,
      };
    }
  },

  // Update client
  updateClient: async (id, clientData) => {
    try {
      const response = await apiClient.put(ENDPOINTS.CLIENTS, {
        ...clientData,
        id,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Update client error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la mise à jour du client',
        error: error.response?.data,
      };
    }
  },

  // Delete client
  deleteClient: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.CLIENTS}/${id}`);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Delete client error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la suppression du client',
        error: error.response?.data,
      };
    }
  },
};

export default clientService;